/**
 * Central configuration for all external URL placeholders.
 * Set values to null to display a "Próximamente disponible" placeholder.
 * Replace null with actual URLs when they become available.
 */
export const LINKS = {
  // === SiGEUS (Distromel) ===
  SIGEUS_BACKOFFICE: null,
  SIGEUS_VISOR: null,
  SIGEUS_VISOR_STM: null,

  // === Valoriza ===
  VALORIZA_PARK: null,
  APP_OPERARIOS: null,

  // === ACTAIS Waste ===
  ACTAIS_BACKOFFICE: null,
  ACTAIS_BACKOFFICE_STM: null,
  ACTAIS_MOBILE: null,
  ACTAIS_CIRCULAR: null,
  ACTAIS_CITIZEN_ADMIN: null,
  ACTAIS_CITIZEN_WEB: '/ecoparque',

  // === Módulos de Calidad y PAYT ===
  MODULO_CALIDAD: null,
  MODULO_PAYT: null,

  // === Personal y accesos ===
  FICHAJE: null,
  FICHAJE_ECOPARQUE: null,

  // === Documentación ===
  DOC_PLANIFICACION: null,

  // === ArcGIS Hub ===
  ARCGIS_HUB_TECNICOS: null,

  // === App ciudadana ===
  APP_IOS: null,
  APP_ANDROID: null,

  // === Formularios ciudadanos ===
  FORMULARIO_INCIDENCIAS: null,
  SOLICITUD_NFC: '/solicitar-nfc',

  // === Contacto ===
  WHATSAPP: null,
  EMAIL_SERVICIO: 'losalcazareslimpio@valorizasm.com',
  TELEFONO: null,
  INSTAGRAM: null,
  FACEBOOK: null,
  X: null,

  // === Logos ===
  LOGO_AYUNTAMIENTO: null,
  LOGO_VALORIZA: null,

  // === Analítica ===
  ANALYTICS_ID: null,

  // === Legales ===
  AVISO_LEGAL: null,
  PRIVACIDAD: null,
  COOKIES: null,
  ACCESIBILIDAD: null,
};
